import React, { useEffect, useRef } from "react";
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  StatusBar,
  Animated,
} from "react-native";
import { FontFamilies } from "@/constants/Typography";
import { ActionButton } from "@/components/ActionButton";
import { router } from "expo-router";
import LottieConfetti from "@/components/LottieConfetti";
import Icons from "@/assets/icons";
import { Ionicons } from "@expo/vector-icons";

const OnboardSuccessScreen = () => {
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scaleAnim = useRef(new Animated.Value(0.8)).current;

  useEffect(() => {
    // Fade in animation
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 800,
      useNativeDriver: true,
    }).start();

    // Scale animation for checkmark
    Animated.spring(scaleAnim, {
      toValue: 1,
      tension: 50,
      friction: 7,
      useNativeDriver: true,
    }).start();
  }, [fadeAnim, scaleAnim]);

  const handleStartFiling = () => {
    router.push("/signup/setup-sparrow");
  };

  return (
    <View style={styles.container}>
      <StatusBar barStyle="dark-content" />
      <SafeAreaView style={styles.container}>
        {/* Sparrow Logo */}
        <View style={styles.logoContainer}>
          <Icons.LogoWithTextBlack width={170} height={38} />
        </View>

        <View style={styles.content}>
          {/* Checkmark */}
          <Animated.View
            style={[
              {
                opacity: fadeAnim,
                transform: [{ scale: scaleAnim }],
              },
            ]}
          >
            <Ionicons name="checkmark-sharp" size={64} color="#0F9129" />
          </Animated.View>

          {/* Success Text */}
          <Animated.View style={[styles.textContainer, { opacity: fadeAnim }]}>
            <Text style={styles.title}>You&apos;re in!</Text>
            <View>
              <Text style={styles.subtitle}>
                Start filing claims instantly. Invite a friend and earn 1 extra
                free claim.
              </Text>
            </View>
          </Animated.View>
        </View>

        {/* Bottom Button */}
        <Animated.View style={[styles.bottomContainer, { opacity: fadeAnim }]}>
          <ActionButton
            title="View My Claims"
            onPress={handleStartFiling}
          />
        </Animated.View>

        {/* Confetti */}
        <LottieConfetti active={true} />
      </SafeAreaView>
    </View>
  );
};

export default OnboardSuccessScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  logoContainer: {
    alignItems: "center",
    paddingTop: 24,
    marginBottom: 10,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
    gap: 32,
  },
  textContainer: {
    alignItems: "center",
    gap: 16,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    color: "#161D14",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    color: "#161D14",
    textAlign: "center",
    opacity: 0.7,
  },
  bottomContainer: {
    paddingHorizontal: 24,
  },
});
